<div class="container" (click)="onToggleDropdown()">
    <div class="background" [ngClass]="{'hide': hideDropDown}"></div>
    <div class="btn">
        AGENDAS
    </div>

    <div class="options-container" (click)="openSchedule()" [ngClass]="{'hide': hideDropDown}">
        <div class="label">
            <span>
                Sala de Espera / Agenda do dia
            </span>
        </div>
    </div>
</div>